import React, { useState, useEffect, useCallback } from 'react';
import ModalZoom from './ModalZoom';
import './admin.css'; // Usamos el CSS del admin para la consistencia neón

import { apiFetch } from '../api';

import { API_BASE_URL, UPLOADS_URL, FOTO_LOCAL_URL } from '../config';

const API = `${API_BASE_URL}/api`;
const URL_FOTOS = UPLOADS_URL;
const URL_FOTO_LOCAL = FOTO_LOCAL_URL;

const esRutaAbsoluta = (url) =>
    /^[A-Za-z]:[\\\/]/.test(url) || String(url || '').startsWith('/');

const getFotoUrl = (foto) => {
    if (!foto?.imagen_url) return '';
    const url = String(foto.imagen_url).trim();
    if (esRutaAbsoluta(url)) {
        return URL_FOTO_LOCAL + encodeURIComponent(url);
    }
    return URL_FOTOS + url.replace(/ /g, '%20').replace(/\\/g, '/');
};

const Eventos = () => {
    const [eventos, setEventos] = useState([]);
    const [eventoActivo, setEventoActivo] = useState(null);
    const [fotosEvento, setFotosEvento] = useState([]);
    const [fotoZoom, setFotoZoom] = useState(null);
    const [creando, setCreando] = useState(false);
    const [form, setForm] = useState({ nombre: '', fecha_inicio: '', fecha_fin: '', descripcion: '' });

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const fotosPorPagina = 15;
    const [saltoInput, setSaltoInput] = useState('1');

    useEffect(() => {
        setSaltoInput(paginaActual.toString());
    }, [paginaActual]);

    // Selección múltiple (fotos)
    const [modoSeleccion, setModoSeleccion] = useState(false);
    const [seleccionadas, setSeleccionadas] = useState([]);

    // Selección múltiple (eventos)
    const [modoSeleccionEventos, setModoSeleccionEventos] = useState(false);
    const [eventosSeleccionados, setEventosSeleccionados] = useState([]);

    const toggleSeleccionEvento = (id) => {
        setEventosSeleccionados(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const seleccionarTodosEventos = () => {
        if (eventosSeleccionados.length === eventos.length) {
            setEventosSeleccionados([]);
        } else {
            setEventosSeleccionados(eventos.map(e => e.id));
        }
    };

    const seleccionarVaciosEventos = () => {
        const vacios = eventos.filter(e => !e.total || e.total === 0).map(e => e.id);
        setEventosSeleccionados(vacios);
    };

    const borrarEventosSeleccionados = async () => {
        if (eventosSeleccionados.length === 0) return;
        const count = eventosSeleccionados.length;
        if (!window.confirm(`¿Eliminar los ${count} evento(s) seleccionado(s)? Esta acción eliminará los eventos, pero las fotos seguirán en la biblioteca general.`)) return;
        try {
            const res = await apiFetch(`${API}/eventos/eliminar-masivo`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ids: eventosSeleccionados })
            });
            if (!res.ok) {
                await Promise.all(eventosSeleccionados.map(id => apiFetch(`${API}/eventos/${id}`, { method: 'DELETE' })));
            }
            setEventosSeleccionados([]);
            setModoSeleccionEventos(false);
            cargar();
        } catch (e) {
            console.error(e);
            alert('Error al eliminar los eventos.');
        }
    };

    const cargar = useCallback(async () => {
        try {
            const res = await apiFetch(`${API}/eventos`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            setEventos(await res.json());
        } catch (e) { console.error(e); }
    }, []);

    useEffect(() => { cargar(); }, [cargar]);

    const abrirEvento = async (ev) => {
        setEventoActivo(ev);
        setPaginaActual(1);
        const res = await apiFetch(`${API}/eventos/${ev.id}/fotos`);
        setFotosEvento(await res.json());
    };

    const crear = async (e) => {
        e.preventDefault();
        if (!form.nombre.trim()) return;
        await apiFetch(`${API}/eventos`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        });
        setForm({ nombre: '', fecha_inicio: '', fecha_fin: '', descripcion: '' });
        setCreando(false);
        cargar();
    };

    const eliminar = async (id) => {
        if (!window.confirm('¿ELIMINAR ESTE EVENTO?')) return;
        await apiFetch(`${API}/eventos/${id}`, { method: 'DELETE' });
        if (eventoActivo?.id === id) { setEventoActivo(null); setFotosEvento([]); }
        cargar();
    };

    const autoEscanear = async () => {
        if (!eventoActivo) return;
        if (!window.confirm('¿Escanear la biblioteca y añadir fotos que coincidan con las fechas de este evento?')) return;
        try {
            const res = await apiFetch(`${API}/eventos/${eventoActivo.id}/auto-scan`, { method: 'POST' });
            const data = await res.json();
            if (data.error) {
                alert('Error: ' + data.error);
            } else {
                alert(`Escaneo completado. Se añadieron ${data.asignadas} fotos al evento.`);
                abrirEvento(eventoActivo); // Recargar fotos
            }
        } catch (e) {
            console.error(e);
            alert('Error al escanear.');
        }
    };

    const navegar = (dir) => {
        if (!fotoZoom) return;
        const idx = fotosEvento.findIndex(f => f.id === fotoZoom.id);
        const next = dir === 'siguiente' ? (idx + 1) % fotosEvento.length : (idx - 1 + fotosEvento.length) % fotosEvento.length;
        setFotoZoom(fotosEvento[next]);
    };

    const manejarClicFoto = (foto) => {
        if (modoSeleccion) {
            setSeleccionadas(prev => 
                prev.includes(foto.id) 
                ? prev.filter(id => id !== foto.id) 
                : [...prev, foto.id]
            );
        } else {
            setFotoZoom(foto);
        }
    };

    const borrarSeleccionadas = async () => {
        if (!window.confirm(`¿Mover ${seleccionadas.length} fotos a la papelera?`)) return;
        try {
            await Promise.all(seleccionadas.map(id => apiFetch(`${API}/imagenes/${id}`, { method: 'DELETE' })));
            setSeleccionadas([]);
            setModoSeleccion(false);
            const res = await apiFetch(`${API}/eventos/${eventoActivo.id}/fotos`);
            setFotosEvento(await res.json());
        } catch (e) { console.error(e); }
    };

    // VISTA DE DETALLE DEL EVENTO (FOTOS)
    if (eventoActivo) return (
        <div className="admin-container">
            <div className="admin-layout-wrapper">
                <header className="admin-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <button className="btn-volver-neon" onClick={() => { setEventoActivo(null); setFotosEvento([]); }}>
                            ⬅ VOLVER
                        </button>
                        <div>
                            <h1 className="admin-title">📅 {eventoActivo.nombre.toUpperCase()}</h1>
                            {eventoActivo.fecha_inicio && (
                                <span className="section-title" style={{ fontSize: '0.65rem' }}>
                                    SISTEMA TEMPORAL: {eventoActivo.fecha_inicio} → {eventoActivo.fecha_fin}
                                </span>
                            )}
                        </div>
                    </div>
                    {eventoActivo.fecha_inicio && (
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button className={`btn-volver-neon ${modoSeleccion ? 'btn-active-fucsia' : ''}`} onClick={() => { setModoSeleccion(!modoSeleccion); setSeleccionadas([]); }}>
                                {modoSeleccion ? '✕ CANCELAR' : '🔍 SELECCIONAR'}
                            </button>
                            <button className="btn-volver-neon" style={{ border: '1px solid var(--acento-turquesa)', color:  'var(--acento-turquesa)'  }} onClick={autoEscanear}>
                                🤖 AUTO-ESCANEAR FECHAS
                            </button>
                        </div>
                    )}
                </header>

                {fotosEvento.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '100px', opacity: 0.5 }}>
                        <p className="section-title">SIN ACTIVOS EN ESTE EVENTO</p>
                    </div>
                ) : (
                    <>
                        {/* BARRA DE ACCIONES POR LOTE */}
                        <div className={`batch-action-bar ${modoSeleccion && seleccionadas.length > 0 ? 'active' : ''}`} style={{ position: 'sticky', top: '10px', zIndex: 100, marginBottom: '15px' }}>
                            <span className="batch-info">{seleccionadas.length} SELECCIONADOS</span>
                            <div className="batch-buttons">
                                <button className="btn-batch btn-delete" onClick={borrarSeleccionadas}>🗑️ BORRAR</button>
                            </div>
                        </div>

                        <div className="masonry-grid" style={{ marginTop: '20px' }}>
                            {fotosEvento.slice((paginaActual - 1) * fotosPorPagina, paginaActual * fotosPorPagina).map(foto => {
                                const isSelected = seleccionadas.includes(foto.id);
                                return (
                                    <div key={foto.id} className={`foto-card ${isSelected ? 'foto-card-seleccionada' : ''}`} onClick={() => manejarClicFoto(foto)}>
                                        <img src={getFotoUrl(foto)} alt={foto.titulo || ''} loading="lazy" />
                                        {modoSeleccion && (
                                            <div className={`select-badge ${isSelected ? 'selected' : ''}`} style={{ position: 'absolute', top: '10px', left: '10px', width: '25px', height: '25px', borderRadius: '50%', border: '2px solid #00ffff', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: isSelected ? '#00ffff' : 'rgba(0,0,0,0.5)', color: '#000', fontWeight: 'bold', fontSize: '14px' }}>
                                                {isSelected ? '✓' : ''}
                                            </div>
                                        )}
                                        <div className="foto-card-overlay">
                                            <div className="foto-card-titulo">{foto.titulo || 'SIN TÍTULO'}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Controles de paginación neón */}
                        <footer className="footer-paginacion" style={{ marginTop: '30px', borderTop: '1px solid #333', paddingTop: '20px' }}>
                            <div className="paginacion-controles">
                                <button 
                                    className="btn-pagi-flecha" 
                                    disabled={paginaActual === 1} 
                                    onClick={() => setPaginaActual(p => p - 1)}
                                >« ANTERIOR</button>
                                
                                <div className="pagi-salto-zona">
                                    <span className="pagi-info">PÁGINA {paginaActual} DE {Math.ceil(fotosEvento.length / fotosPorPagina)}</span>
                                    <div className="input-salto-wrapper">
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            className="input-salto-neon"
                                            value={saltoInput}
                                            onChange={e => setSaltoInput(e.target.value.replace(/\D/g, ''))}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter') {
                                                    const num = parseInt(saltoInput);
                                                    if (num > 0 && num <= Math.ceil(fotosEvento.length / fotosPorPagina)) {
                                                        setPaginaActual(num);
                                                    }
                                                }
                                            }}
                                            placeholder="..."
                                        />
                                        <button className="btn-ir-pagi" onClick={() => {
                                            const num = parseInt(saltoInput);
                                            if (num > 0 && num <= Math.ceil(fotosEvento.length / fotosPorPagina)) {
                                                setPaginaActual(num);
                                            }
                                        }}>IR</button>
                                    </div>
                                </div>

                                <button 
                                    className="btn-pagi-flecha" 
                                    disabled={paginaActual >= Math.ceil(fotosEvento.length / fotosPorPagina)} 
                                    onClick={() => setPaginaActual(p => p + 1)}
                                >SIGUIENTE »</button>
                            </div>
                        </footer>
                    </>
                )}

                {fotoZoom && (
                    <ModalZoom
                        foto={fotoZoom}
                        onClose={() => setFotoZoom(null)}
                        onNavigate={navegar}
                        onBorrar={async (id) => {
                            await apiFetch(`${API}/imagenes/${id}`, { method: 'DELETE' });
                            setFotoZoom(null);
                            const r = await apiFetch(`${API}/eventos/${eventoActivo.id}/fotos`);
                            setFotosEvento(await r.json());
                        }}
                        getFotoUrl={getFotoUrl}
                        setBusqueda={() => { }}
                    />
                )}
            </div>
        </div>
    );

    // VISTA PRINCIPAL DE EVENTOS
    return (
        <div className="admin-container">
            <div className="admin-layout-wrapper">
                <header className="admin-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <h1 className="admin-title">📅 EVENTOS</h1>
                        <span className="section-title" style={{ fontSize: '0.65rem', margin: 0 }}>REGISTRO CRONOLÓGICO</span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {eventos.length > 0 && (
                            <button
                                className={`btn-volver-neon ${modoSeleccionEventos ? 'btn-active-fucsia' : ''}`}
                                onClick={() => {
                                    setModoSeleccionEventos(!modoSeleccionEventos);
                                    setEventosSeleccionados([]);
                                }}
                            >
                                {modoSeleccionEventos ? '✕ CANCELAR SELECCIÓN' : '🔍 SELECCIONAR'}
                            </button>
                        )}
                        <button className="btn-volver-neon" onClick={() => setCreando(c => !c)}>
                            {creando ? '✕ CANCELAR' : '+ NUEVO EVENTO'}
                        </button>
                    </div>
                </header>

                {modoSeleccionEventos && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: '#0a0a0f',
                        border: '1px solid rgba(0, 255, 255, 0.4)',
                        boxShadow: '0 0 25px rgba(0, 255, 255, 0.15)',
                        padding: '12px 20px',
                        borderRadius: '10px',
                        marginBottom: '20px',
                        flexWrap: 'wrap',
                        gap: '12px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                            <span style={{ fontFamily: 'monospace', fontWeight: 'bold', color: '#00ffff', fontSize: '0.9rem', letterSpacing: '1px' }}>
                                {eventosSeleccionados.length} SELECCIONADO{eventosSeleccionados.length === 1 ? '' : 'S'} (DE {eventos.length})
                            </span>
                            <button
                                type="button"
                                className="btn-volver-neon"
                                style={{ padding: '6px 14px', fontSize: '0.75rem' }}
                                onClick={seleccionarTodosEventos}
                            >
                                {eventosSeleccionados.length === eventos.length ? 'DESELECCIONAR TODOS' : 'SELECCIONAR TODOS'}
                            </button>
                            {eventos.some(e => !e.total || e.total === 0) && (
                                <button
                                    type="button"
                                    className="btn-volver-neon"
                                    style={{ padding: '6px 14px', fontSize: '0.75rem', borderColor: '#ff00ff', color: '#ff00ff' }}
                                    onClick={seleccionarVaciosEventos}
                                    title="Selecciona todos los eventos con 0 activos"
                                >
                                    ⚡ SELECCIONAR VACÍOS (0 ACTIVOS)
                                </button>
                            )}
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                                type="button"
                                className="btn-volver-neon"
                                style={{
                                    borderColor: '#ff0055',
                                    color: '#ff0055',
                                    padding: '6px 16px',
                                    fontSize: '0.8rem',
                                    boxShadow: eventosSeleccionados.length > 0 ? '0 0 15px rgba(255, 0, 85, 0.5)' : 'none',
                                    opacity: eventosSeleccionados.length > 0 ? 1 : 0.4,
                                    cursor: eventosSeleccionados.length > 0 ? 'pointer' : 'not-allowed'
                                }}
                                disabled={eventosSeleccionados.length === 0}
                                onClick={borrarEventosSeleccionados}
                            >
                                🗑️ ELIMINAR SELECCIONADOS {eventosSeleccionados.length > 0 ? `(${eventosSeleccionados.length})` : ''}
                            </button>
                        </div>
                    </div>
                )}

                {creando && (
                    <section className="admin-card" style={{ marginBottom: '20px' }}>
                        <form onSubmit={crear} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                            <input className="admin-input" placeholder="Nombre del evento" value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} required style={{ flex: 2, minWidth: 150 }} />
                            <input className="admin-input" type="date" value={form.fecha_inicio} onChange={e => setForm(f => ({ ...f, fecha_inicio: e.target.value }))} style={{ flex: 1 }} />
                            <input className="admin-input" type="date" value={form.fecha_fin} onChange={e => setForm(f => ({ ...f, fecha_fin: e.target.value }))} style={{ flex: 1 }} />
                            <input className="admin-input" placeholder="Descripción técnica" value={form.descripcion} onChange={e => setForm(f => ({ ...f, descripcion: e.target.value }))} style={{ flex: 3 }} />
                            <button type="submit" className="btn-volver-neon" style={{ border: '1px solid #00ffff', color: '#00ffff' }}>INJECTAR</button>
                        </form>
                    </section>
                )}

                <div className="eventos-grid">
                    {eventos.map(ev => {
                        const isSelected = eventosSeleccionados.includes(ev.id);
                        return (
                            <div
                                key={ev.id}
                                className="admin-card"
                                style={{
                                    cursor: 'pointer',
                                    position: 'relative',
                                    borderColor: modoSeleccionEventos && isSelected ? '#00ffff' : undefined,
                                    boxShadow: modoSeleccionEventos && isSelected ? '0 0 18px rgba(0, 255, 255, 0.4)' : undefined,
                                    background: modoSeleccionEventos && isSelected ? 'rgba(0, 255, 255, 0.06)' : undefined,
                                    transition: 'all 0.2s ease'
                                }}
                                onClick={() => modoSeleccionEventos ? toggleSeleccionEvento(ev.id) : abrirEvento(ev)}
                            >
                                {modoSeleccionEventos && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '50%',
                                        border: `2px solid ${isSelected ? '#00ffff' : 'rgba(255, 255, 255, 0.4)'}`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: isSelected ? '#00ffff' : 'rgba(0, 0, 0, 0.6)',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        boxShadow: isSelected ? '0 0 10px #00ffff' : 'none',
                                        zIndex: 2
                                    }}>
                                        {isSelected ? '✓' : ''}
                                    </div>
                                )}

                                <div style={{ fontSize: '2.5rem', marginBottom: '10px', filter: 'drop-shadow(0 0 5px #ff00ff)' }}>📅</div>
                                <h3 className="admin-title" style={{ fontSize: '1.1rem', marginBottom: '5px' }}>{ev.nombre.toUpperCase()}</h3>
                                {ev.fecha_inicio && (
                                    <div style={{ fontSize: '0.72rem', color: '#00ffff', marginBottom: '10px', fontFamily: 'monospace' }}>
                                        [{ev.fecha_inicio}] {'>>'} [{ev.fecha_fin}]
                                    </div>
                                )}

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px', borderTop: '1px solid #333', paddingTop: '10px' }}>
                                    <span className="tag-badge" style={{ background: 'rgba(255, 0, 255, 0.1)', color: '#ff00ff' }}>
                                        {ev.total || 0} ACTIVOS
                                    </span>
                                    {!modoSeleccionEventos && (
                                        <button className="btn-action-icon-morado btn-borrar" onClick={e => { e.stopPropagation(); eliminar(ev.id); }}>
                                            🗑️
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {eventos.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '100px', opacity: 0.5 }}>
                        <p className="section-title">NO SE DETECTAN EVENTOS EN EL ARCHIVO</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Eventos;
